/**
 * M5-A: Onboarding-Status pro User (First-Run-Gating).
 *
 * Limitation: localStorage ist browser-lokal — ein User, der den Browser
 * wechselt oder den Speicher leert, gilt wieder als "neu" und sieht die
 * Einführung nach dem Login erneut. Serverseitiges Flag folgt in einem
 * späteren Milestone.
 */
const KEY_PREFIX = 'mindkeep:onboarding-done'

export function onboardingDoneKey(userId: string): string {
  return `${KEY_PREFIX}:${userId}`
}

export function isOnboardingDone(userId: string | null | undefined): boolean {
  if (!userId || typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(onboardingDoneKey(userId)) === '1'
  } catch {
    return false
  }
}

export function markOnboardingDone(userId: string | null | undefined): void {
  if (!userId || typeof window === 'undefined') return
  try {
    window.localStorage.setItem(onboardingDoneKey(userId), '1')
  } catch {
    // Storage voll/blockiert — dann wird die Einführung halt erneut gezeigt.
  }
}
